import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LoginForm } from "@/components/auth/LoginForm";
import { Logo } from "@/components/layout/Logo";

export default function Login() {
  const { user } = useAuth();
  const navigate = useNavigate();

  if (user) return <Navigate to="/dashboard" replace />;

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:flex flex-col justify-between bg-navy text-white p-12 relative overflow-hidden">
        <img src="https://images.unsplash.com/photo-1541339907198-e08756dedf3f?w=1200&q=80" alt="" className="absolute inset-0 h-full w-full object-cover opacity-25" />
        <div className="absolute inset-0 bg-gradient-to-br from-navy-deep to-navy/60" />
        <div className="relative"><Logo light /></div>
        <div className="relative">
          <h2 className="headline text-5xl">Welcome back to <span className="text-orange">Elite</span></h2>
          <p className="text-white/70 mt-4 max-w-md">Pick up your applications, chat with your advisor and manage your favorites.</p>
        </div>
        <div className="relative text-white/40 text-xs">© 2026 Elite by Thotis Media</div>
      </div>

      <div className="flex items-center justify-center p-6 sm:p-12 bg-background">
        <div className="w-full max-w-sm">
          <div className="flex justify-center mb-8"><Logo heightClass="h-20" /></div>
          <div className="eyebrow text-xs text-orange mb-2 text-center">Sign in</div>
          <h1 className="headline text-4xl text-navy mb-8 text-center">Log in</h1>
          <LoginForm onSuccess={() => navigate("/dashboard")} />
        </div>
      </div>
    </div>
  );
}
